import styled from 'styled-components';

interface IProps {
  className: string;
}

export const Title = styled.h1<IProps>`
  color: #000;
  font-weight: 600;
  position: relative;
`;

export const Suffix = styled.span`
  position: absolute;
  top: 0;
  right: 0;
`;
